/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Datastore API
 * API reference for Datastore API.
 *
 * Authentication: Auth0
 *
 * OpenAPI spec version: 3.0.0
 */
import type {
  UpdateDamageRequestBody,
  UpdateDamageResponse
} from '../model';

import putDamagesMutator from '../../../mutators/datastore-instance';



  /**
 * ファイルのダメージ情報を更新する
 * @summary ダメージ作成
 */
export const putDamages = (
    fileId: number,
    updateDamageRequestBody?: UpdateDamageRequestBody,
 ) => {
      return putDamagesMutator<UpdateDamageResponse>(
      {url: `/files/${fileId}/damages`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateDamageRequestBody
    },
      );
    }
  export type PutDamagesResult = NonNullable<Awaited<ReturnType<typeof putDamages>>>
